import CustomPopoverConfirm from "@UI/CustomPopoverConfirm"
import { Button } from "antd"
import { ReactComponent as CleanTableIcon } from './assets/cleanTable.svg'
import './styles.css'
import { useCollectionEditTableOptions } from "./hooks/useCollectionEditTableOptions"

const CollectionEditTableOptions = () => {
    const { handleDownloadTemplate, handleCleanTable } = useCollectionEditTableOptions()
    return (
        <div className="collection-edit-table-options">
            <CustomPopoverConfirm
                trigger={'hover'}
                content={`${0 >= 30 ?
                    'No tienes permiso para realizar esta acción' :
                    'DESCARGAR PLANTILLA'}`
                }>
                <div>
                    <Button
                        onClick={() => handleDownloadTemplate()}
                        className="btn-standard-white"
                        shape="round"
                        style={{ width: 'fit-content', height: '32px' }}
                    >
                        DESCARGAR PLANTILLA
                    </Button>
                </div>
            </CustomPopoverConfirm>
            <div>
                <Button
                    onClick={() => handleCleanTable()}
                    className="btn-standard-white"
                    shape="round"
                    style={{ width: 'fit-content', height: '32px' }}
                    icon={<CleanTableIcon />}
                >
                    LIMPIAR TABLA
                </Button>
            </div>
        </div>
    )
}

export default CollectionEditTableOptions
